import Decimal from 'decimal.js';
import { OrderBookItem, OrderBookSide } from '@/lib/types/order-book';

export type PriceVolumeCumulative = OrderBookItem & {
  cumulativeVolume: Decimal;
  cumulativeShares: Decimal;
  side: OrderBookSide;
};

export function getWithCumulativeTotals(
  priceVolumes: OrderBookItem[],
  side: OrderBookSide,
): PriceVolumeCumulative[] {
  const sorted = priceVolumes.toSorted((a, b) => {
    return side === 'asks' ? Number(a.price) - Number(b.price) : Number(b.price) - Number(a.price);
  });

  const out: PriceVolumeCumulative[] = [];
  let cumulativeVolume = Decimal(0);
  let cumulativeShares = Decimal(0);

  for (let i = 0; i < sorted.length; i++) {
    const cur = sorted[i];
    cumulativeVolume = cumulativeVolume.add(Decimal(cur.size).mul(cur.price));
    cumulativeShares = cumulativeShares.add(Decimal(cur.size));
    out.push({
      ...cur,
      cumulativeVolume: cumulativeVolume,
      cumulativeShares: cumulativeShares,
      side: side,
    });
  }

  return side === 'asks' ? out.reverse() : out;
}
